import {Typography, useTheme} from "@mui/material";
import {formatCurrency, formatNumber, formatPercent} from "../utils/formatters";
import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material";
import {LoadingSpinner} from "../utils/loading_spinner";

export const KpiPanel = ({chartType, data, dataPrevious, showTitle = false, onHeaderClick, loading = false}) => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;
    const indicatorTheme = theme.palette.indicator;

    if (loading) {
        return (
            <div style={{...panelTheme, paddingTop: 10, paddingBottom: 10, width: dims.smallPanelWidth, textAlign: "center"}}>
                {showTitle &&
                    <Typography variant="body1">{chartType.name}</Typography>
                }
                <LoadingSpinner message="Loading..." size={32}/>
            </div>
        );
    }

    const formatValue = (value) => {
        switch (data.valueType) {
            case 'currency':
                return formatCurrency(value, true);
            case 'count':
                return formatNumber(value);
            case 'percent':
                return formatPercent(value, 2);
            default:
        }
    };

    const changeIsGood = () => {
        const lowerIsBetter = chartType.apiPath.startsWith('cost') || chartType.apiPath.startsWith('reduction');
        return (lowerIsBetter && data.value - dataPrevious.value < 0) || (!lowerIsBetter && data.value - dataPrevious.value > 0);
    };

    const determineColor = () => {
        return changeIsGood() ? indicatorTheme.green : indicatorTheme.red;
    };

    console.log("data: ", data);
    console.log("dataPrevious: ", dataPrevious);
    const percentChangeString = formatPercent((data.value - dataPrevious.value) / dataPrevious.value, 1, true);

    return (
        <div style={{...panelTheme, paddingTop: 10, paddingBottom: 10, width: dims.smallPanelWidth, textAlign: "center"}}>
            <div 
                onClick={onHeaderClick}
                style={{
                    cursor: onHeaderClick ? 'pointer' : 'default'
                }}
            >
                {showTitle &&
                    <Typography variant="body1">{chartType.name}</Typography>
                }
                <Typography variant="h3" display="inline" color={determineColor()}>{formatValue(data.value)}</Typography>
                {changeIsGood() && <ArrowDropUp style={{fontSize: 40, color: indicatorTheme.green}}/>}
                {!changeIsGood() && <ArrowDropDown style={{fontSize: 40, color: indicatorTheme.red}}/>}
                <Typography variant="h6">Prior period: {formatValue(dataPrevious.value)} ({percentChangeString})</Typography>
            </div>
        </div>
    );
};